<template>
  <div>
    <layout
      :licenseTypeName="licenseTypeName"
      :licenseType="form.licenseType"
      :amount="calcRes.amount"
      :originalAmount="calcRes.originalAmount"
      @submit="handleSave"
      :loadingCalc="loadingCalc"
      :loadingSubmit="loadingSubmit"
    >
      <template v-slot:center>
        <div class="my-m-t-20">
          <el-form :model="form" label-position="left" label-width="80px">
            <el-form-item label="购买时长">
              <el-radio-group v-model="form.years" v-if="form.licenseType == 'Client_PC'" class="my-m-t-10">
                <el-radio :label="1">1年</el-radio>
                <el-radio :label="0">不限时间</el-radio>
              </el-radio-group>
              <div v-else>不限时间</div>
            </el-form-item>
            <el-form-item label="联系人" v-if="form.licenseType == 'Client_DOG' || form.licenseType == 'Client_USB'">
              <el-input placeholder="联系人" v-model="form.contactName" clearable style="max-width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label>
              <span slot="label">{{ form.licenseType == 'Client_PC'?'手机号码':'联系电话' }}</span>
              <el-input
                :placeholder="form.licenseType == 'Client_PC'?'接收授权码（必填）':'联系电话'"
                v-model="form.contactTel"
                clearable
                style="max-width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="详细地址" v-if="form.licenseType == 'Client_DOG' || form.licenseType == 'Client_USB'">
              <el-input placeholder="请填写收货的详细地址" v-model="form.contactAddress" clearable style="max-width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="购买须知">
              <div class="my-type-info my-font-sm">
                <div v-if="form.licenseType == 'Client_PC'">激活码可以绑定1台电脑，永久使用，更换电脑时接在原设备上解绑后绑定新电脑，无需重复购买。</div>
                <div v-else>请填写正确的联系方式，付款成功后24小时内给您邮寄，并联系您发送快递单号。</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </layout>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import API from '@/api/soft'
import API_ORDER from '@/api/order'
import layout from './components/_layout.vue'
export default {
  components: { layout },
  name: 'BuyAlone',
  data() {
    return {
      loadingCalc: false,
      loadingSubmit: false,
      form: {
        product: this.utils.getProductCode(),
        licenseType: '', //版本
        years: '', //时长
        code: '', //机器码
        contactEmail: '', //邮箱
        contactName: '', //姓名
        contactTel: '', //手机号
        contactAddress: '', //地址
        details: [],
        invite: ''
      },
      licenseTypeName: '',
      freeList: [],
      f: {},
      calcRes: { amount: 0, originalAmount: 0 }
    }
  },
  watch: {
    'form.years': {
      handler() {
        this.calcAmount()
      }
    }
  },
  computed: {
    ...mapGetters(['softPrice']),
    isAloneYear() {
      if (this.form.licenseType == 'Client_PC' && this.softPrice.alone_PC_Year_Price) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    console.log(this.$route.params)

    //提前加载数据
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())

    this.form.licenseType = this.$route.params.licenseType
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    if (this.isAloneYear) {
      this.form.years = 1
    } else {
      this.form.years = 0
    }
    switch (this.form.licenseType) {
      case 'Client_PC':
        this.licenseTypeName = '单机电脑版'
        break
      case 'Client_DOG':
        this.licenseTypeName = '单机加密狗版'
        this.form.years = 0
        break
      case 'Client_USB':
        this.licenseTypeName = '单机优盘版'
        this.form.years = 0
        break
      default:
        this.licenseTypeName = ''
    }
    // this.calcAmount()
  },

  methods: {
    handleSave() {
      let title = this.validation()
      if (title == 'OK') {
        this.postOrderCreate()
      } else {
        this.$Message({
          showClose: true,
          message: title,
          type: 'error'
        })
      }
    },
    validation() {
      if (this.form.licenseType === 'Client_PC') {
        // if (!this.form.code) return '请填写机器码'
        // if (!this.form.contactEmail) return '请填写邮箱'
        if (!this.form.contactTel) return '请填写手机号码'
      }
      if (this.form.licenseType === 'Client_DOG' || this.form.licenseType === 'Client_USB') {
        if (!this.form.contactName) return '请填写联系人'
        if (!this.form.contactTel) return '请填写联系电话'
        if (!this.form.contactAddress) return '请填写详细地址'
      }
      return 'OK'
    },
    postOrderCreate() {
      let obj = this.form
      obj.form = 'Web'
      obj.details = this.setDetails()
      console.log('postOrderCreate:', obj)

      this.loadingSubmit = true
      API_ORDER.postOrderCreate(obj).then(res => {
        this.loadingSubmit = false
        this.$router.push({ name: 'OrderConfirm', query: { orderNo: res.data } })
      })
    },
    setDetails() {
      let details = []
      if (this.form.licenseType == 'Client_PC') {
        details.push({
          currentType: 'None',
          currentTypeText: '未开通',
          licenseTimeEnd: '0001-01-01',
          licenseModule: 'License',
          changeType: this.form.years >= 1 ? 'BuyYears' : 'BuyForever',
          licenseValue: '',
          years: this.form.years
        })
      } else if (this.form.licenseType == 'Client_DOG') {
        details.push({
          currentType: 'None',
          currentTypeText: '未开通',
          licenseTimeEnd: '0001-01-01',
          licenseModule: 'License',
          changeType: 'BuyForever',
          licenseValue: '',
          years: this.form.years
        })
      } else if (this.form.licenseType == 'Client_USB') {
        details.push({
          currentType: 'None',
          currentTypeText: '未开通',
          licenseTimeEnd: '0001-01-01',
          licenseModule: 'License',
          changeType: 'BuyForever',
          licenseValue: '',
          years: this.form.years
        })
      }
      return details
    },
    //邀请码查询优惠
    getAgentFreeAmount() {
      if (this.form.invite) {
        API.getAgentFreeAmount({ invite: this.form.invite }).then(res => {
          console.log(res)
          this.calcAmount()
        })
      }
    },
    //调通接口计算价格
    calcAmount() {
      let obj = {
        product: this.utils.getProductCode(),
        licenseType: this.form.licenseType,
        invite: this.form.invite,
        code: '',
        details: this.setDetails()
      }
      this.loadingCalc = true
      API_ORDER.postOrderCalcAmount(obj).then(res => {
        this.loadingCalc = false
        this.calcRes = res.data
      })
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', ' background:#eee;')
  }
}
</script>